import { json } from "@sveltejs/kit";
import { s as sendLicenseEmail } from "../../../../../../chunks/mailer.js";
import { g as get, L as LicenseCollection } from "../../../../../../chunks/firebase.js";
const GET = async ({ url }) => {
  const email = url.searchParams.get("email");
  if (!email) {
    return json(
      {
        success: false,
        message: "No email provided"
      },
      { status: 400 }
    );
  }
  const license = await get(LicenseCollection(), email);
  if (!license?.data) {
    return json(
      {
        success: false,
        message: "No license found for this email"
      },
      { status: 404 }
    );
  }
  await sendLicenseEmail(email, license.data.code, "Thank you for purchasing a pro license.");
  return json({
    success: true,
    message: "License email sent successfully"
  });
};
export {
  GET
};
